import { render } from "./LazyPictureTag.vue?vue&type=template&id=64d84d82&scoped=true"
import script from "./LazyPictureTag.vue?vue&type=script&lang=js"
export * from "./LazyPictureTag.vue?vue&type=script&lang=js"

import "./LazyPictureTag.vue?vue&type=style&index=0&id=64d84d82&lang=scss&scoped=true"

import exportComponent from "/data01/virt24076/domeenid/www.rallyestonia.ee/htdocs/ui/template/rallyestonia/moduleTmpl/shop/VueBasket/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d84d82"]])

export default __exports__